import moment from 'moment'
import {
  MAX_EXTENDED_HOUR,
  MAX_EXTENDED_MINUTE,
} from '@medical/libs/extendedTimeUtils'

const startTime = '7:00'
const normalEndTime = '23:59'
const step = 1

const getMoment = val => {
  const t = val.split(':')
  const tt = moment()
  tt.hours(t[0])
  tt.minutes(t[1])
  tt.seconds(0)
  return tt
}

const result = []

// Part 1: 07:00 → 23:59 (standard hours using moment)
const fromTime = getMoment(startTime)
const toTime = getMoment(normalEndTime)

while (fromTime.isSameOrBefore(toTime)) {
  result.push(fromTime.format('HH:mm'))
  fromTime.add(step, 'minute')
}

// Part 2: 24:00 → 26:00 (extended hours for overnight shifts)
// Cannot use moment here since moment max hour is 23.
// At the max hour (26) only :00 is allowed — no 26:01–26:59.
for (let h = 24; h <= MAX_EXTENDED_HOUR; h++) {
  const maxMinute = h < MAX_EXTENDED_HOUR ? 59 : MAX_EXTENDED_MINUTE
  for (let m = 0; m <= maxMinute; m++) {
    result.push(`${h}:${String(m).padStart(2, '0')}`)
  }
}

export default result
